module.exports = __webpack_public_path__ + "static/index/img/baikal-705.0ad6d08f.jpg";